
import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";

function BitcoinTechPage80() {

  const contentRef = useRef(null);
  const titleText = " A Tour of Bitcoins Key Concensus Rules";
  const links = {
    prev: "/bitcoin-tech-page-79",
    index: "/index-bitcoin-tech",
    next: "/bitcoin-tech-page-81",
  };

  const questions = [
  {
    text: "1. What enforces Bitcoin’s fixed supply cap of 21 million BTC?",
    options: [
      { value: "A", label: "A. The block size limit" },
      { value: "B", label: "B. The difficulty adjustment algorithm" },
      {
        value: "C",
        label: "C. The block subsidy halving logic in GetBlockSubsidy",
      },
      { value: "D", label: "D. Mempool policy rules" },
    ],
    correct: "C",
  },
  {
    text: "2. What condition must be true for a block to pass Proof-of-Work validation?",
    options: [
      {
        value: "A",
        label: "A. The block hash must be greater than the target",
      },
      {
        value: "B",
        label: "B. The block hash must exactly equal the target",
      },
      {
        value: "C",
        label: "C. The block hash must be less than or equal to the target",
      },
      {
        value: "D",
        label: "D. The block must contain at least one transaction",
      },
    ],
    correct: "C",
  },
  {
    text: "3. Why does Bitcoin adjust mining difficulty every 2016 blocks?",
    options: [
      {
        value: "A",
        label: "A. To limit the total number of miners",
      },
      {
        value: "B",
        label: "B. To maintain an average block time of 10 minutes",
      },
      {
        value: "C",
        label: "C. To increase transaction throughput",
      },
      {
        value: "D",
        label: "D. To reduce block size",
      },
    ],
    correct: "B",
  },
  {
    text: "4. What happens if a transaction violates a Bitcoin consensus rule?",
    options: [
      {
        value: "A",
        label: "A. It may still be accepted depending on miner preference",
      },
      {
        value: "B",
        label: "B. It is rejected by the entire network as invalid",
      },
      {
        value: "C",
        label: "C. It is delayed but eventually confirmed",
      },
      {
        value: "D",
        label: "D. It is accepted but not relayed",
      },
    ],
    correct: "B",
  },
];

  
   // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);
  

  const supply_cap = `CAmount GetBlockSubsidy(int nHeight, const Consensus::Params& consensusParams)
{
    int halvings = nHeight / consensusParams.nSubsidyHalvingInterval;
    if (halvings >= 64) return 0;
    CAmount nSubsidy = 50 * COIN;
    nSubsidy >>= halvings;
    return nSubsidy;
}`;

  const block_weight = `static const unsigned int MAX_BLOCK_WEIGHT = 4000000;
static const unsigned int MAX_BLOCK_SERIALIZED_SIZE = 4000000;
static const unsigned int MAX_BLOCK_BASE_SIZE = 1000000;
`;
  const proof_of_work = `bool CheckProofOfWork(uint256 hash, unsigned int nBits, const Consensus::Params& params)
{
    arith_uint256 bnTarget;
    bool fNegative;
    bool fOverflow;
    bnTarget.SetCompact(nBits, &fNegative, &fOverflow);
    if (fNegative || bnTarget == 0 || fOverflow || bnTarget > params.powLimit)
        return false;
    if (UintToArith256(hash) > bnTarget)
        return false;
    return true;
}
`;
  const difficulty = `unsigned int GetNextWorkRequired(const CBlockIndex* pindexLast, const CBlockHeader* pblock, const Consensus::Params& params)
{
    assert(pindexLast != nullptr);
    unsigned int nProofOfWorkLimit = UintToArith256(params.powLimit).GetCompact();
    if ((pindexLast->nHeight+1) % params.DifficultyAdjustmentInterval() != 0)
    {
        if (params.fPowAllowMinDifficultyBlocks)
        {
            if (pblock->GetBlockTime() > pindexLast->GetBlockTime() + params.nPowTargetSpacing*2)
                return nProofOfWorkLimit;
            else
            {
                const CBlockIndex* pindex = pindexLast;
                while (pindex->pprev && pindex->nHeight % params.DifficultyAdjustmentInterval() != 0 && pindex->nBits == nProofOfWorkLimit)
                    pindex = pindex->pprev;
                return pindex->nBits;
            }
        }
        return pindexLast->nBits;
    }
    int nHeightFirst = pindexLast->nHeight - (params.DifficultyAdjustmentInterval()-1);
    assert(nHeightFirst >= 0);
    const CBlockIndex* pindexFirst = pindexLast->GetAncestor(nHeightFirst);
    assert(pindexFirst);
    return CalculateNextWorkRequired(pindexLast, pindexFirst->GetBlockTime(), params);
}
`;
  const timestamp = `bool CheckBlockTime(const CBlockHeader& block, const CBlockIndex* pindexPrev)
{
    int64_t nMedianTimePast = pindexPrev->GetMedianTimePast();
    if (block.GetBlockTime() <= nMedianTimePast)
        return false;
    if (block.GetBlockTime() > GetAdjustedTime() + MAX_FUTURE_BLOCK_TIME)
        return false;
    return true;
}
`;
  const sig_validation = `bool EvalScript(std::vector<std::vector<unsigned char> >& stack, const CScript& script, unsigned int flags, const BaseSignatureChecker& checker, SigVersion sigversion, ScriptError* serror)
{
    // [Script evaluation logic]
    if (opcode == OP_CHECKSIG || opcode == OP_CHECKSIGVERIFY)
    {
        // [Signature verification logic]
        if (!checker.CheckSig(vchSig, vchPubKey, scriptCode, sigversion))
            return set_error(serror, SCRIPT_ERR_CHECKSIGVERIFY);
    }
    // [More script evaluation logic]
}
`;
  const UTXO_unspent = `bool CheckTxInputs(const CTransaction& tx, CCoinsViewCache& inputs, const CChainParams& chainparams, int nSpendHeight, CAmount& txfee)
{
    if (!inputs.HaveInputs(tx))
        return false;

    // Additional validation logic...
}
`;
  const no_double_spend = `bool AcceptToMemoryPool(CTxMemPool& pool, std::shared_ptr<CTransaction> tx, std::string& errMsg)
{
    LOCK(pool.cs);
    if (pool.exists(tx->GetHash()))
        return false;

    // Additional validation logic...
}
`;
  const consensus = `bool ContextualCheckBlock(const CBlock& block, const CBlockIndex* pindexPrev, const Consensus::Params& consensusParams)
{
    if (block.nVersion < 2)
        return false;

    // Additional version and rule checks...
}
`;
  return (
    <div className="container">
     
     <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={80}
        timerMinutes={90}
        currentLevel={6}
        unlockedBadges={11}
      />

      
      <p className="content" ref={contentRef}>
        Welcome to <b>Day 80</b>!
Today’s lesson takes you on a deep dive into Bitcoin’s consensus rules, the foundational principles that ensure every node in the network agrees on what is valid. You’ll explore how rules like the 21 million BTC supply cap, proof-of-work, difficulty adjustment, and transaction validation are enforced at the protocol level, and why these rules are critical to Bitcoin’s security, decentralization, and immutability. By the end of this lesson, you’ll understand not just what the rules are, but how Bitcoin’s code enforces them to keep the network trustworthy and resilient.<br/><br/>
       <b>What Are Consensus Rules and Their Importance?</b><br/><br/>
        Consensus rules are the fundamental protocol-level rules that all
        Bitcoin nodes must enforce to maintain a single, consistent ledger
        across the network. These rules dictate how blocks and transactions are
        validated, ensuring that all participants in the Bitcoin network agree
        on the state of the blockchain. <br />
        Some key consensus rules include the total supply cap of 21 million BTC,
        the block size limit, the proof-of-work mechanism, and transaction
        validation criteria. These rules are crucial because they establish the
        security, trustlessness, and predictability of Bitcoin. Unlike
        traditional financial systems where central authorities can modify
        monetary policies, Bitcoin’s consensus rules are designed to be
        immutable unless the entire network agrees to a protocol upgrade, often
        through a soft fork or hard fork. <br />
        Without these rules, Bitcoin’s decentralized nature would collapse,
        leading to inconsistencies, double spending, or even complete breakdown
        of the network’s integrity. <br />
        By ensuring that every full node follows the same validation criteria,
        consensus rules protect against fraudulent activities and provide the
        basis for Bitcoin’s monetary policy, making it resistant to manipulation
        by any single entity.
        <br />
        <br />
        <b>Difference Between a Policy Rule and a Consensus Rule</b>
        <br />
        <br />
        While consensus rules are strict protocol-level rules that all nodes
        must enforce for a block or transaction to be considered valid, policy
        rules are local rules applied by individual nodes when deciding what
        transactions to accept into their mempool or relay to other peers.{" "}
        <br />A key distinction is that breaking a consensus rule results in an
        invalid block or transaction that will be rejected by the entire
        network, whereas policy rules are more flexible and can vary from node
        to node. <br />
        <br />
        For example, a consensus rule requires that every transaction’s
        signatures must be valid according to Bitcoin’s scripting rules; if they
        aren’t, the transaction is invalid for everyone. In contrast, a policy
        rule might set a minimum transaction fee threshold for transactions to
        be relayed or included in a block, but this threshold can be different
        for different nodes and miners. <br />
        Policy rules help optimize network efficiency and mitigate spam, but
        they do not affect the fundamental security or validity of transactions.{" "}
        <br />
        In essence, consensus rules define the unbreakable laws of Bitcoin,
        while policy rules are more like best practices that individual nodes
        and miners can choose to follow or modify based on their own
        preferences.
        <br />
        <br />
        <b>Key Consensus Rules in Bitcoin</b>
        <br />
        <br />
        Bitcoin's consensus rules define the protocol's validity conditions that
        all full nodes enforce. Let's go through some key consensus rules and
        understand them:
        <br />
        <br />
        <br />
        <br />
        <b>1. 21 Million BTC Supply Cap</b>
        <br />
        <br />
        Code Reference: src/validation.cpp​
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{supply_cap}</pre>
      </div>
      <p className="content">
        Explanation: This function calculates the block subsidy (new bitcoins
        created) based on the block height. The subsidy starts at 50 BTC and
        halves every nSubsidyHalvingInterval blocks (210,000 blocks). After 64
        halvings, the subsidy becomes zero, capping the total supply at 21
        million BTC.​
        <br />
        <br />
        <b>2. Block Size Limit</b> (4MB Weight via SegWit, ~1MB Base Size)
        <br />
        <br />
        Code Reference: src/consensus/consensus.h​
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{block_weight}</pre>
      </div>
      <p className="content">
        Explanation: These constants define the maximum sizes for blocks: 4MB
        weight (including SegWit data), 4MB serialized size, and 1MB base size
        (pre-SegWit). These limits ensure network stability and prevent
        excessively large blocks.
        <br />
        <br />
        <b>3. Proof-of-Work (PoW) with SHA-256​</b>
        <br />
        <br />
        Code Reference: src/pow.cpp​ ​
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{proof_of_work}</pre>
      </div>
      <p className="content">
        Explanation: This function verifies that a block's hash meets the
        required difficulty target (nBits). It ensures the hash is below the
        target, confirming the block's validity under the PoW consensus
        mechanism.​
        <br />
        <br />
        <b>4. Difficulty Adjustment Every 2016 Blocks (~2 Weeks)</b>
        <br />
        <br />
        Code Reference: src/pow.cpp
      </p>

      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{difficulty}</pre>
      </div>
      <p className="content">
        Explanation: This function calculates the required difficulty for the
        next block. It adjusts every 2016 blocks to maintain an average block
        time of 10 minutes, accommodating changes in network hash rate. <br />
        <br />
        <b>5. Valid Block Timestamps (Median Past Time Rule)</b>
        <br />
        <br />
        Code Reference: src/validation.cpp
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{timestamp}</pre>
      </div>
      <p className="content">
        Explanation: This function ensures a block's timestamp is greater than
        the median of the previous 11 blocks and not more than 2 hours into the
        future, maintaining chronological consistency. <br />
        <br />
        <b>6. Block Reward Halving</b>
        <br />
        <br />
        Code Reference: src/script/interpreter.cpp
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{supply_cap}</pre>
      </div>
      <p className="content">
        <br />
        <br />
        Explanation: The GetBlockSubsidy function handles the halving of the
        block subsidy every 210,000 blocks, reducing the reward by half to
        control the rate of new bitcoin creation.
        <br />
        <br />
        <b>7. Transaction Signatures Must Be Valid</b>
        <br />
        <br />
        Code Reference: src/script/interpreter.cpp
      </p>

      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{sig_validation}</pre>
      </div>
      <p className="content">
        Explanation: This function is one of the core components of Bitcoin’s
        script engine. It executes the script (which is a sequence of opcodes
        and data), evaluates stack-based operations, and ensures everything is
        valid according to the Bitcoin scripting language rules.
        <br />
        <br />
        <b>
          8. Unspent Transaction Outputs (UTXOs) Must Be Available and Not Spent
        </b>
        <br />
        <br />
        Code Reference: src/validation.cpp
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{UTXO_unspent}</pre>
      </div>
      <p className="content">
        Explanation: The CheckTxInputs function verifies that all inputs of a
        transaction exist in the UTXO set and have not been spent. The
        inputs.HaveInputs(tx) call checks for the presence of the required
        UTXOs. If any input is missing or already spent, the transaction is
        deemed invalid.
        <br />
        <br />
        <b>9. No Double Spending Allowed</b>
        <br />
        <br />
        Code Reference: src/validation.cpp
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{no_double_spend}</pre>
      </div>
      <p className="content">
        Explanation: The AcceptToMemoryPool function checks if a transaction
        already exists in the mempool by calling pool.exists(tx-{">"}GetHash()).
        If the transaction is already present, it indicates an attempt to
        double-spend, and the new transaction is rejected. This ensures that
        each UTXO is spent only once.
        <br />
        <br />
        <b>10. Consensus Rules Cannot Be Changed Without a Fork</b>
        <br />
        <br />
        Code Reference: src/validation.cpp
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{consensus}</pre>
      </div>
      <p className="content">
        Explanation: The ContextualCheckBlock function ensures that blocks
        adhere to the expected versioning and consensus rules. By checking
        block.nVersion, the function enforces that only blocks with acceptable
        versions are considered valid. Changes to consensus rules typically
        require a version increment and coordination among nodes, preventing
        unauthorized alterations without a hard fork. <br />
        <br />
        These code snippets from Bitcoin Knots illustrate how the software
        enforces critical consensus rules to maintain the integrity and security
        of the Bitcoin network.<br/><br/>
        <b>Summary of Today’s Lesson</b><br/><br/>
        Today’s lesson focused on Bitcoin’s consensus rules and why they are essential to the network’s security and reliability. You learned how rules such as the 21 million BTC supply cap, proof-of-work validation, difficulty adjustment, block size limits, timestamp requirements, and UTXO enforcement are implemented directly in the Bitcoin codebase and enforced by every full node. The lesson also highlighted the critical difference between consensus rules and policy rules, emphasizing that consensus rules define what is universally valid on the network and can only change through coordinated forks. Overall, this lesson showed how Bitcoin maintains a single, consistent ledger without central authority by relying on strict, transparent, and predictable consensus rules.
<br/><br/>
      </p>
      <h2>Test your understanding</h2>
      
  
     {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)}
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />

    </div>
  );
}

export default BitcoinTechPage80;
